module.exports = __webpack_public_path__ + "img/ring_y_0_null_null.ba3273d9.png";